import $ from 'jquery'
import React from 'react'
import { Component } from 'react'


class Spinner extends Component {

    render() {
        return (
            <span className={"spinner" + (this.props.active ? " active": " hide")}>
                <i className={"icon icon-spinner5"}/>
            </span>
        );
    }
}


export default Spinner


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/LoadingSpinner.js